<template>
  <div class="layout-main">
    <n-layout-cool :menu="navigation" :profile="profile" :companies="$d.get('companies')" :select-company="selectCompany">
      <template #logo><n-link :to="{name: 'index'}"><img :src="logo" style="height: 28px" /></n-link></template>
      <template #logo-min>{{ names['logoMin'] }}</template>
      <template #avatar><n-image centered round :src="$app.auth.user().avatar || avatar" /></template>
      <template #name>{{ $app.auth.user() ? $app.auth.user().fullName : '' }}</template>
      <template #company-name>{{ company.title }}</template>
      <div slot="content">
        <page-title />
        <router-view />
      </div>
      <div slot="footer">
        iQurylys v1.1.7
        <br />
        ТОО «Direct Construction Service»
        <br />
        <n-link to="#" @click="$var('errorRequest', true)">Сообщить об ошибке</n-link>
      </div>
    </n-layout-cool>
    <cards />

    <error-request v-if="$var('errorRequest')" @close="$var('errorRequest', false)" />
  </div>
</template>

<script>
import avatar from 'assets/images/avatar.png'
import logo from 'assets/images/logo.png'
import PageTitle from './../../components/pageTitle/Index'
import names from './../names'
import Cards from './../../cards/Index'
import ErrorRequest from './ErrorRequest'

export default {
  name: 'MainLayout',
  components: { ErrorRequest, Cards, PageTitle, },
  html() {
    return {
      title: this.names['product'],
    }
  },
  data: () => ({
    show: false,
    names: names(),
    logo,
    avatar,
    profile: [
      { title: 'Профиль', icon: 'user', route: 'profile', },
      { title: 'Выход', icon: 'sign-out-alt', route: 'login', },
    ],
  }),
  computed: {
    company() {
      return $app.store.getter('app.company')
    },
    navigation() {
      return $app.router.navigation($config('router.navigation')())
    },
  },
  watch: {
    '$store.state.auth.user'() {
      this.checkAuth()
    },
  },
  created() {
    this.checkAuth()
  },
  methods: {
    checkAuth() {
      if (!$app.auth.user()) {
        this.$router.push({ name: 'login', })
        return false
      }
      return true
    },
    selectCompany(company) {
      $app.store.mutation('app.company', company)
      this.$router.go()
    },
  },
}
</script>

<style lang="scss">
  @import url('https://fonts.googleapis.com/css?family=Ubuntu:100,100i,300,300i,400,400i,500,500i,700,700i,900,900i');
  @import '~nast-ui/src/style/global';
  
  @include initialize((
    default: (
      colors: (
        primary: #3472e3,
        secondary: #ffd200,
        tertiary: #c556ff,
      ),
      typography: (
        header-font: 'Ubuntu, sans-serif',
        text-font: '400 1em Ubuntu, sans-serif',
        h1-font: '300 2em var(--header-font)',
        h3-font: '400 1.2em var(--header-font)',
        text-color: #444,
      ),
    ),
  ));
  
  .layout-main {
    .n-layout-cool {
      .n-aside {
        .n-logo-full > .n-logo {
          padding: 5px 0 3px;
        }
      }
    }
    
    .container {
      padding: 10px;
    }
  }
  
  .sub {
    font-size: .9em;
    opacity: .9;
  }
  
  .table-tools {
    margin-bottom: 10px;
  }
</style>
